import TabToggle from 'components/commons/tab-toogle'
import TabToggleList from 'components/commons/tab-toogle-list'
import { Button, InlineError } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import UploadImage from 'components/commons/upload-image'

export const BannerPromoBrand = ({ items, setItems, onChangeItem, onAddNewItem, errorForm }) => {
    const getError = (key, index) => {
        const findError = errorForm?.promotion_banners_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <TabToggle
            title={'Banner Promo Brand'}
            content={
                <div className={'flex flex-col space-y-6'}>
                    {items?.map((item, index) => (
                        <TabToggleList
                            key={`banner-${index}`}
                            index={index}
                            title={`Banner-${index + 1}`}
                            content={
                                <div className={'flex space-x-16'}>
                                    <div
                                        className={`flex-1 flex-col ${(item?.desktop_image_url?.base64 || item?.desktop_image_url?.length) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90'}>
                                            Banner Desktop (953px x 357px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`logo-brand-desktop-${index}`}
                                            value={item?.desktop_image_url?.base64 || item?.desktop_image_url}
                                            onChange={(value) =>
                                                onChangeItem({
                                                    name: 'desktop_image_url',
                                                    value,
                                                    index,
                                                })
                                            }
                                        />
                                        <InlineError className='mt-2' message={getError('desktop_image_url', index)} />
                                    </div>
                                    <div
                                        className={`flex-1 flex-col ${(item?.mobile_image_url?.base64 || item?.mobile_image_url?.length) && 'space-y-3'}`}
                                    >
                                        <div className={'font-semibold text-blue-90'}>
                                            Banner Mobile (393px x 243.01px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`logo-brand-mobile-${index}`}
                                            value={item?.mobile_image_url?.base64 || item?.mobile_image_url}
                                            onChange={(value) =>
                                                onChangeItem({
                                                    name: 'mobile_image_url',
                                                    value,
                                                    index,
                                                })
                                            }
                                        />
                                        <InlineError className='mt-2' message={getError('mobile_image_url', index)} />
                                    </div>
                                </div>
                            }
                            items={items}
                            setItems={setItems}
                            isSorting
                        />
                    ))}
                    <InlineError className='mt-2' message={errorForm?.promotion_banners} />
                    <Button
                        className={'w-fit'}
                        type={'outline'}
                        icon={icAddSquare}
                        title={'Add New Item'}
                        onClick={onAddNewItem}
                    />
                </div>
            }
        />
    )
}
